import React, { useEffect, useState } from "react"
import { RadioSelect } from "@mallardbay/lib-react-components"

// TODO: Switch to use the shared component lib modal
import MbModal from "~components/shared/mb-modal"
import { PaymentPlanType } from "~graphql/generated/graphql"
import type { QuotePaymentPlanFieldsFragment } from "~graphql/generated/graphql"
import {
    Text,
    TextBold,
} from "~components/shared/todo-lib-react-components/text"
import Box from "~components/shared/todo-lib-react-components/box"
import { VerticalStack } from "~components/shared/todo-lib-react-components/vertical-stack"
import PaymentPlanRadioOption from "~components/pages/book/payment-plan-radio-option"
import COPY from "~config/copy-constants"

interface Props {
    readonly value: PaymentPlanType
    readonly onChange: (value: PaymentPlanType) => void
    readonly paymentPlans: QuotePaymentPlanFieldsFragment[]
    readonly isLoading?: boolean
}

export default function PaymentPlanForm({
    value,
    onChange,
    paymentPlans,
    isLoading,
}: Props) {
    const [isOpen, setIsOpen] = useState(false)

    useSetDefaultPaymentPlanType({ paymentPlans, onChange })

    return (
        <div>
            <RadioSelect
                value={value}
                onChange={onChange}
                options={paymentPlans}
                getOptionValue={(paymentPlan) => paymentPlan.type}
                renderOption={(paymentPlan) => (
                    <PaymentPlanRadioOption
                        paymentPlan={paymentPlan}
                        onLearnMoreClick={() => setIsOpen(true)}
                        isLoading={isLoading}
                    />
                )}
            />

            <MbModal
                title={COPY.HOW_IT_WORKS}
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
            >
                <InfoModalContent />
            </MbModal>
        </div>
    )
}

function InfoModalContent() {
    const configs = getPaymentPlanInfoConfigs()

    return (
        <VerticalStack>
            {configs.map(({ title, subtitle }) => (
                <Box key={title}>
                    <Text>{title}</Text>
                    <TextBold>{subtitle}</TextBold>
                </Box>
            ))}
        </VerticalStack>
    )
}

function getPaymentPlanInfoConfigs() {
    return [
        {
            title: COPY.PAYMENT_PLAN_INFO_SECTION_A_LINE_1,
            subtitle: COPY.PAYMENT_PLAN_INFO_SECTION_A_LINE_2,
        },
        {
            title: COPY.PAYMENT_PLAN_INFO_SECTION_B_LINE_1,
            subtitle: COPY.PAYMENT_PLAN_INFO_SECTION_B_LINE_2,
        },
        {
            title: COPY.PAYMENT_PLAN_INFO_SECTION_C_LINE_1,
            subtitle: COPY.PAYMENT_PLAN_INFO_SECTION_C_LINE_2,
        },
    ]
}

// right now the default state for payment plan is set higher in the component tree than
// fetch the available payment plans. This is a temporary solution to set the default
// after having access to the payment plans.
function useSetDefaultPaymentPlanType({
    paymentPlans,
    onChange,
}: {
    paymentPlans: QuotePaymentPlanFieldsFragment[]
    onChange: (value: PaymentPlanType) => void
}) {
    const payInTwoType = paymentPlans.find(
        (plan) => plan.type === PaymentPlanType.PayInTwo
    )

    useEffect(() => {
        if (payInTwoType) {
            onChange(payInTwoType.type)
        }
    }, [paymentPlans.length])
}
